// third-party
import { FormattedMessage } from "react-intl";

// assets

import enums from "utils/enums";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import FastfoodIcon from '@mui/icons-material/Fastfood';
import { ShoppingCartOutlined, StarOutlineOutlined, Person } from "@mui/icons-material";
// icons
const icons = {
  ShoppingCartOutlined,
  StarOutlineOutlined,
  RateReviewOutlinedIcon,
  FastfoodIcon,
  Person
};

// ==============================|| MENU ITEMS - MAIN ||============================== //

const order = {
  id: "order",
  type: "group",
  title: <FormattedMessage id="orderList" />,
  roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin, enums.userRole.SiteManager, enums.userRole.User, enums.userRole.EdmExport],
  children: [
    {
      id: "orderList",
      title: <FormattedMessage id="orderList" />,
      type: "item",
      url: "order/orders",
      roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin, enums.userRole.SiteManager, enums.userRole.User],
      icon: icons.ShoppingCartOutlined,
      isShowFilter: true,
      subTitle: "Manage Orders",
      showTitle: false
    },
    {
      id: "feedback",
      title: <FormattedMessage id="feedback" />,
      type: "item",
      url: "order/feedback",
      roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin, enums.userRole.SiteManager, enums.userRole.User],
      icon: icons.StarOutlineOutlined,
      isShowFilter: true,
      showTitle: true
    },
    {
      id: "sitefeedback",
      title: <FormattedMessage id="sitefeedback" />,
      type: "item",
      url: "order/sitefeedback",
      roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin, enums.userRole.SiteManager, enums.userRole.User],
      icon: icons.RateReviewOutlinedIcon,
      isShowFilter: true,
      showTitle: true
    },
    {
      id: "customer",
      title: <FormattedMessage id="customer" />,
      type: "item",
      url: "order/customer",
      icon: icons.Person,
      roleTags: [enums.userRole.EdmExport],
      isShowFilter: true,
      subTitle: "Manage Customers",
      showTitle: false
    }
  ],
};

export default order;
